import React from 'react';
import { Container } from 'react-bootstrap';
import styles from './ClinicPage.module.scss';
import DashboardButtonsCard from '../components/DashboardButtonsCard';
import { useNavigate } from 'react-router-dom';

type ClinicPageProps = {
  user: User | null;
};

const ClinicPage: React.FC<ClinicPageProps> = ({ user }) => {
const navigate = useNavigate();

  return (
    <>
      <Container className="center">
        <h2 className={styles["title"]}>Consultório</h2>
        <DashboardButtonsCard
          welcomeMessage={`Olá, ${user?.name.split(' ')[0] || 'nutricionista'}! Bem-vindo(a) ao seu consultório.`}
          buttons={[
            //{ text: 'Meus pacientes', onClick: () => navigate('/consultorio/pacientes') },
            //{ text: 'Minha agenda', onClick: () => navigate('/consultorio/agenda') },
            //{ text: 'Controle Financeiro', onClick: () => console.log('Gerenciar Consultas') },
            //{ text: 'Meus materias', onClick: () => navigate('/consultorio/materiais') },
            //{ text: 'Meus relatórios', onClick: () => console.log('Gerenciar Exames') },
          ]}
        />
      </Container>
    </>
  );
};

export default ClinicPage;
